import { Preload } from "@react-three/drei";
import { useDracoGLTF } from "../../utils/useDracoGLTF";
import { Ebbne, MountWithEbbne, useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";
import { Suspense, useEffect } from "react";
import { ref } from "valtio";
import { cameraStore } from "../../appStore";
import LoadingCallback from "../LoadingCallback";

import FactsAndFigures from "./factsandfigures/FactsAndFigures";
import Section from "./Section";
import SubSection from "./SubSection";
import { UIPortal } from "@solidwhite/ui-portal";
import { FactAndFiguresUITransition } from "../ui/Sections/FactsAndFigures/FactAndFiguresUI";
import HeatingProducts from "./products/HeatingProducts";
import HeatingIndustries from "./industries/HeatingIndustries";
import HeatingApplications from "./applications/HeatingApplications";
import { SideBarHider } from "../ui/SideBar/SideBar";
import { MountAutoplay } from "../MountAutoplay.tsx";

const HeatingScene = ({ ...props }) => {
  const { active } = useEbbne();

  return (
    <group>
      <HeatingSections />
    </group>
  );
};

const HeatingCamPosition = ({ camSettings }) => {
  const { active } = useEbbne();

  useEffect(() => {
    if (active) {
      cameraStore.cameraTargetSettings = ref(camSettings);
    }
  }, [active]);

  return null;
};

const HeatingSections = ({}) => {
  const { nodes, scene } = useDracoGLTF("./models/heat/main.glb");

  return (
    <>
      <HeatingCamPosition camSettings={nodes.CameraTarget} />

      <HeatingProducts nodes={nodes} />

      <HeatingIndustries nodes={nodes} />

      <HeatingApplications nodes={nodes} />

      {import.meta.env.MODE === "electron" && (
        <MountWithEbbne>
          <MountAutoplay path={"guest/autoplay-heat.json"} />
        </MountWithEbbne>
      )}
    </>
  );
};

export const Services = ({ nodes }) => {
  return (
    <group position={nodes.services.position} rotation={nodes.services.rotation}>
      <Ebbne id="services">
        <Section object3d={nodes.services} />
        <MountWithEbbne>
          <SideBarHider />
        </MountWithEbbne>

        <Ebbne id="rental" visibleWithAbove={2}>
          <SubSection object3d={nodes.rental} />
        </Ebbne>
        <Ebbne id="consultation" visibleWithAbove={2}>
          <SubSection object3d={nodes.consultation} />
        </Ebbne>
        {/* <Ebbne id="coilService" visibleWithAbove={2}>
          <SubSection object3d={nodes.coilService} />
        </Ebbne> */}
        <Ebbne id="maintenance" visibleWithAbove={2}>
          <SubSection object3d={nodes.maintenance} />
        </Ebbne>
      </Ebbne>
    </group>
  );
};

export const FactsNFigures = ({ nodes }) => {
  return (
    <Ebbne id="factsfigures">
      <MountWithEbbne mountedWhen={"active"}>
        <group position={nodes.factsfigures.position} rotation={nodes.factsfigures.rotation}>
          <FactsAndFigures />
        </group>
        <UIPortal>
          <FactAndFiguresUITransition key="FactsAndFigures_UI" />
        </UIPortal>
      </MountWithEbbne>

      <group position={nodes.factsfigures.position} rotation={nodes.factsfigures.rotation}>
        <Section object3d={nodes.factsfigures} />
      </group>
    </Ebbne>
  );
};

useDracoGLTF.preload("./models/heat/main.glb");

export default HeatingScene;
